import React from "react"
import $ from "jquery"
import concatWithSpaces from "../../../../../ProjectNonSpecificComponents/Functions/concatWithSpaces"
import { TSelectedTableRowId } from "components/ProjectSpecificComponents/Interfaces/TableInterface"
import { Tr } from "./StyledComponents/TableStyleComp"

interface Props extends React.ComponentProps<"tr"> {
	row: any
	rowId: TSelectedTableRowId
	i: number
	tableRow: any
	selectedRowId?: TSelectedTableRowId
	showPointer?: boolean
	onClick?: (e: any) => void
}
type TMouseEnter = React.MouseEvent<HTMLTableRowElement, MouseEvent>

export default function TableRow({
	row,
	rowId,
	i,
	tableRow,
	selectedRowId,
	showPointer,
	style,
	className,
	onMouseEnter = () => {},
	onMouseLeave = () => {},
	onClick = () => {},
	...props
}: Props) {
	const stavoklis: number = row?.stavoklis ?? 0
	const isRowSelected = selectedRowId !== undefined && selectedRowId === row?.id

	return (
		<Tr
			onMouseEnter={(e: TMouseEnter) => {
				// Pārbauda vai vērtība ir null/undefined, jo null == undefined
				rowId != null && hoverRow(`${rowId}_${i}`)
				onMouseEnter(e)
			}}
			onMouseLeave={(e: TMouseEnter) => {
				hoverRow(`${rowId}_${i}`)
				onMouseLeave(e)
			}}
			className={concatWithSpaces(
				isRowSelected ? "selected" : "",
				`${stavoklis > 0 && `rowStatus_${stavoklis}`} ${rowId}_${i}`,
				showPointer ? "pointer" : "",
				className
			)}
			style={{
				textAlign: "right",
				...style,
			}}
			onClick={onClick}
		>
			{tableRow(row, i)}
		</Tr>
	)
}

export const hoverRow = (_class: string) => {
	$("." + `${_class}`).toggleClass("selected-row")
}
